import React, { FC, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import StockLocationEquipmentsForm from '../stock_location_equipments_form/StockLocationEquipmentsForm';
import { stockLocationsRestCrudThunksForSupplier } from '../../thunks/stock_locations_thunks';
import { EditPage } from '../edit_page/EditPage';
import LogOnMountWithStandardEventProperties from '../log_on_mount_with_standard_event_properties/LogOnMountWithStandardEventProperties';
import { DEFAULT_NAME_SORTER } from '../../utils/DataConstants';
import { equipmentPerStockLocationsRestCrudThunksForSupplier } from '../../thunks/equipment_per_stock_locations_thunks';

require('./EditStockLocationEquipmentsPage.less');

const EditStockLocationEquipmentsPage: FC<any> = ({
	history,
	stockLocation,
	fetching,
	match,
	getStockLocation,
	fetchEquipmentsPerStockLocation,
}): React.ReactElement => {
	const stockLocationId = useMemo(() => match.params.id, [match.params.id]);
	const [equipmentsAtStockLocation, setEquipmentAtStockLocation] = useState([]);
	const [fetchingEpsl, setFetchingEpsl] = useState(false);

	useEffect(() => {
		//Fetching from previous page rerenders the edit component
		//So restricting the call to only one, so that the rerender doesn't happen
		!fetching && getStockLocation(stockLocationId);
	}, [getStockLocation, stockLocationId]);

	useEffect(() => {
		setFetchingEpsl(true);
		fetchEquipmentsPerStockLocation(
			{ stockLocationId, isDisbursed: false },
			null,
			{
				current: 1,
				pageSize: 1000,
			},
			DEFAULT_NAME_SORTER
		)
			.then((res) => setEquipmentAtStockLocation(res))
			.finally(() => setFetchingEpsl(false));
	}, [fetchEquipmentsPerStockLocation, stockLocationId]);

	const loading = useMemo(() => fetching || fetchingEpsl, [fetching, fetchingEpsl]);

	return (
		<>
			<LogOnMountWithStandardEventProperties eventType="visited supplier edit stock location equipments page" />
			,
			<EditPage
				title="Edit Stock Location Equipment"
				formComponentProps={{
					formData: {
						...stockLocation,
						equipmentsAtStockLocation,
					},
					onSuccess: (id) => history.push(`/supplier/stockLocations/detail/${id}/equipments`),
				}}
				fetching={loading}
				FormComponent={StockLocationEquipmentsForm}
			/>
			,
		</>
	);
};

const mapStateToProps = (state, ownProps) => {
	return {
		history: ownProps.history,
		stockLocation: state.stock_locations.detail,
		fetching: state.stock_locations.fetching,
		match: ownProps.match,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getStockLocation: (id) => dispatch(stockLocationsRestCrudThunksForSupplier.readOne(id)),
	fetchEquipmentsPerStockLocation: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			equipmentPerStockLocationsRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(EditStockLocationEquipmentsPage)
);
